<template>
  <a class="c-category-card" :href="category.url">
    <img
      ref="image"
      class="c-category-card__image"
      :src="category.imageUrl"
      :alt="category.title"
    />
    <h3 class="c-category-card__title">
      {{ category.title }}
    </h3>
  </a>
</template>

<script>
export default {
  name: 'ComponentCategoryCard',
  props: {
    category: { type: Object, required: true },
  },
  mounted() {
    this.$refs.image.onerror = () => {
      this.$refs.image.src = this.category.noImageUrl
    }
  },
}
</script>

<style lang="scss" scoped>
@use '~/scss/generic/mixins';

.c-category-card {
  align-items: center;
  display: flex;
  transition: 0.3s;

  &:hover {
    opacity: 0.6;
  }

  &__image {
    display: block;
    height: 44px;
    width: 44px;

    @include mixins.screen-desktop {
      height: 60px;
      width: 60px;
    }
  }

  &__title {
    font-size: 13px;
    font-weight: 600;
    margin-left: 12px;
  }
}
</style>
